import { render } from "./CounterpartyIndividualPersonForm.vue?vue&type=template&id=15fb5528"
import script from "./CounterpartyIndividualPersonForm.vue?vue&type=script&lang=js"
export * from "./CounterpartyIndividualPersonForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__